module.exports = __webpack_public_path__ + "static/media/JAI 05.2c0ad5c2.jpg";